<template>
    <div>
        <div class="container">
            <!-- <div class="row">
                <div class=" col-xl-12 text-center font-glacial-regular font-70 mt-xl-4 pt-xl-4 mb-xl-4 pb-xl-2 mt-4 mb-2">
                    <h1 class="text-center font-glacial-regular font-70">
                        {{data.titulo}}
                    </h1>
                </div>
            </div> -->
            <!-- <div class="row d-flex justify-content-center mt-4 mt-xl-0">
                <div class="col-xl-10 text-center font-glacial-regular text-gray-light font-18 mb-xl-5 pb-xl-4 mb-3">
                    <h4 class="text-center font-glacial-regular text-gray-light font-18">
                        {{data.descricao}}
                    </h4>
                </div>
            </div> -->
            <div class="row justify-content-center pt-4 pt-xl-0">

                    <div class="d-xl-flex d-flex-wrap d-md-flex justify-content-center align-items-center mt-xl-5 mt-md-5 pl-2 pt-xl-1 mb-xl-5 mb-md-5">
                        <!-- <b-link router-tag="a" :to="`/autores`" 
                            class="font-glacial-bold font-15 font-size-blog pr-xl-5 pr-md-4 d-block d-xl-block text-center" 
                            :class="{'text-categories-red' : selected == 2}">
                            AUTORES
                        </b-link> -->

                        <a href="javascript:void(0)" class="font-glacial-bold font-15 font-size-blog pr-xl-5 pr-md-4 d-block d-xl-block text-center" 
                            @click="changeCategory(8)"
                            :class="{'text-categories-red' : selected == 8}">
                            GERAL
                        </a>
        
                        <div v-for="(d, index) in categories" :key="index">
                            <b-link href="javascript:void(0)" class="font-glacial-bold font-15 font-size-blog pr-xl-5 pr-md-4 text-uppercase d-block d-xl-block btn-pointer text-center" 
                                @click="changeCategory(d.id)" 
                                :class="{'text-categories-red' : selected == d.id}">
                                {{d.name}}
                            </b-link>
                        </div>
                    </div>
                </div>
            <div class="row mt-5 pt-3 mb-3">
                <div class="col-xl-4 col-md-6 mb-4" v-for="(d, index) in postsSliced" :key="index" >
                    <div class="mb-2 height-257 border-round d-flex justify-content-center align-items-center shadow-video background-image" 
                        :style="`background-image: url(${d.better_featured_image.source_url})`"
                        >
                            <div class="btn-play-white" @click="doPlay(true, d)"></div>
                    </div>
                    <p class="text-center font-glacial-regular font-20" v-html="d.title.rendered"></p>
                </div>
                <div class="container d-flex justify-content-center" key="msg">
                    <div class="font-glacial-regular font-30 pt-4 pb-3 pt-5 pb-5 mb-4 mt-4 mt-md-0 mt-lg-0 mt-xl-0 text-gray-light text-center" v-if="!loading && posts.length == 0">
                        Esta categoria ainda não possui conteúdo
                    </div>
                </div>
            </div>
            <!-- <div class="row d-flex justify-content-center mb-4" v-if="posts && posts.length < total">
                <button class="btn btn-ver-mais btn-secondary col-xl-2 mb-3 mt-2" @click="loadMore" :disabled="loading">
                </button>
            </div> -->
        </div>
        <b-modal 
            :visible="(loadedId ? true : false)"
            @hide="doPlay(false)" 
            ref= "modal"
            body-class="modal-videos p-0" 
            size="lg" 
            hide-footer 
            hide-header  
            centered 
        >
            <iframe width="100%" height="400px" :src="`https://www.youtube.com/embed/${loadedId}?&autoplay=1`" 
            frameborder="0" allow="autoplay; encrypted-media" allowfullscreen v-if="play"></iframe>
        </b-modal>
    </div>
</template>
<script>
    export default {
        props:{
            data: null
        },
        created(){
            this.loadMore();
            this.load();
        },
        data(){
            return {
                play: false,
                posts: null,
                page: 0,
                loading: false,
                total: 0,
                indexData: 3,
                loadedId: null,
                category: 0,
                selected: 8,
                categories: null,
            }
        },

        mounted() {
            var self = this
            window.addEventListener("scroll", function(e){
                var h = document.documentElement,
                b = document.body,
                st = 'scrollTop',
                sh = 'scrollHeight';

                self.scrollPercentage = (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100
            
                if(self.scrollPercentage >= 40.00){
                    self.indexData += 3
                }
            })

            if (this.$route.params.id) {
                this.loadedId = this.$route.params.id
                this.play = true
            }

        },

        methods:{
            changeCategory(cat) {
                this.selected = cat
                this.posts = []
                this.category = cat

                this.loadMore()
            },
            doPlay(status, video = null) {
                this.play = status

                if (this.play) {
                    this.loadedId = video.acf.id_video
                    window.history.pushState(null, document.title, `/videos/play/${encodeURIComponent(video.slug)}/${video.acf.id_video}`);
                } else {
                    this.loadedId = null
                    window.history.pushState(null, document.title, `/videos`);            
                }
            },

            loadMore(){
                this.page++

                this.loading = true

                var url = window.SETTINGS.API_BASE_PATH + "posts?_embed&categories=8&per_page=100"
                
                if (this.category > 0) {
                    url += `&categories=${this.category}`
                }

                axios.get(url).then(response => {
                    this.total = response.headers["x-wp-total"]
                    
                    this.posts = response.data


                })

                this.loading = false
            },

            async load(){
                var url = window.SETTINGS.API_BASE_PATH + "categories?_embed&parent=8"

                var response = await axios.get(url)
                this.categories = response.data
            }
        },
        
        computed:{
            postsSliced(){
                this.loading = true

                if (!this.posts) {
                    return
                }
                
                this.loading = false
                return this.posts.slice(0, this.indexData)

            },
        }
    }
</script>
<style scoped>
.box-center {
    margin: 20px auto;
}
.spinner:after {
    background: #FF0002 !important;
}

a,
a:hover {
    color: #212529
}

a.text-categories-red,
a.text-categories-red:hover {
    color: #ff0004;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/videos.vue